import { useEffect, useState } from 'react';
import { getServerUrl } from '../utils/getServerUrl';
import { useUniversalNavContext } from './useUniversalNavContext';
import { useQuerySession } from './useQuerySession';

import type { UniversalNavLinkType } from '../constants';
import { fallbackSidebarLinks } from '../components/UniversalSidebar/constants';

export const useQuerySidebar = () => {
  const { getFullyQualifiedURL } = useUniversalNavContext();
  const [sideNavData, setSideNavData] =
    useState<UniversalNavLinkType[]>(fallbackSidebarLinks);
  const { data: sessionData } = useQuerySession();

  useEffect(() => {
    let apiSubscribed = true;

    async function getSidebarUrlData() {
      const serverUrl = getServerUrl();
      const sidebarUrl = `${serverUrl}/api/v2/navigation-data/sidebar`;

      const currentAccountId = sessionData?.currentAccountId?.toString() || '';
      const isStaff = sessionData?.isStaff?.toString() || '';
      const userId = sessionData?.customUserId?.toString() || '';

      try {
        const response = await fetch(sidebarUrl, {
          credentials: 'include',
          headers: {
            'x-is-staff': isStaff,
            'x-current-account-id': currentAccountId,
            'x-customuser-id': userId,
          },
        });
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          setSideNavData(data);
        }
      } catch (error) {
        if (apiSubscribed) {
          setSideNavData(fallbackSidebarLinks);
        }
      }
    }

    getSidebarUrlData();

    return () => {
      apiSubscribed = false;
    };
  }, [getFullyQualifiedURL, sessionData]);

  return { sideNavData };
};
